/** Gooval Open Platform API — debug catalog (paths relative to /open/v1) */

export const REFERENCE_COLLECTIONS = [
  'countries',
  'carriers',
  'product-categories',
  'endorse-scenes',
  'cancel-reasons'
]

/** 默认打开的接口（路由 hashId） */
export const DEFAULT_ENDPOINT_HASH_ID = 'quote'

export const REFERENCE_LABELS = {
  countries: '国家列表',
  carriers: '承运商',
  'product-categories': '商品类目',
  'endorse-scenes': '批改场景',
  'cancel-reasons': '取消原因'
}

export const endpointGroups = [
  {
    id: 'reference',
    label: '参考数据',
    endpoints: REFERENCE_COLLECTIONS.map((collection) => ({
      id: `ref-${collection}`,
      hashId: `ref-${collection}`,
      label: `GET reference-data/${collection}`,
      summary: REFERENCE_LABELS[collection] || collection,
      method: 'GET',
      path: '/reference-data/{collection}',
      pathParams: { collection },
      readOnlyPathParams: ['collection'],
      queryParams: [],
      body: null,
      idempotent: false
    }))
  },
  {
    id: 'policies',
    label: '保单',
    endpoints: [
      {
        id: 'quote',
        hashId: 'quote',
        label: 'POST policies/quote',
        summary: '报价',
        method: 'POST',
        path: '/policies/quote',
        pathParams: {},
        queryParams: [],
        body: {
          externalReference: 'ORD-DEBUG-001',
          risk: {
            insuredAmount: { amount: 10000, currencyCode: 'USD' },
            destination: { countryCode: 'US' },
            departure: { countryCode: 'CN' }
          }
        },
        idempotent: true
      },
      {
        id: 'apply',
        hashId: 'apply',
        label: 'POST policies/apply',
        summary: '投保申请',
        method: 'POST',
        path: '/policies/apply',
        pathParams: {},
        queryParams: [],
        body: {
          externalReference: 'ORD-DEBUG-001',
          orderPlacedAt: new Date().toISOString().replace(/\.\d{3}Z$/, 'Z'),
          risk: {
            insuredAmount: { amount: 10000, currencyCode: 'USD' },
            destination: { countryCode: 'US' },
            departure: { countryCode: 'CN' },
            lineItems: [
              {
                itemId: 'LINE-001',
                sku: 'SKU-001',
                name: 'Sample product',
                category: 'apparel',
                quantity: 2,
                unitPrice: { amount: 5000, currencyCode: 'USD' },
                imageUrl: 'https://cdn.example.com/item.jpg'
              }
            ]
          },
          buyer: {
            name: 'Jane Doe',
            email: 'buyer@example.com'
          },
          merchantShop: { id: 'shop_debug', name: 'Debug Shop' },
          metadata: { channel: 'debug' }
        },
        idempotent: true,
        hint:
          'orderPlacedAt 须为过去 24 小时内；金额均为整数最小货币单位（分）。响应含 policyNo，不含 spNumber。'
      },
      {
        id: 'upload-url',
        hashId: 'upload-url',
        label: 'POST policies/attachments/upload-url',
        summary: '附件上传地址',
        method: 'POST',
        path: '/policies/attachments/upload-url',
        pathParams: {},
        queryParams: [],
        body: {
          contentType: 'application/pdf',
          contentLength: 1024,
          type: 'invoice',
          fileName: 'invoice.pdf'
        },
        idempotent: false,
        hint: '预签名 URL 900 秒有效；非 24h 幂等。'
      },
      {
        id: 'get-policy',
        hashId: 'get-policy',
        label: 'GET policies/{policyNo}',
        summary: '保单详情',
        method: 'GET',
        path: '/policies/{policyNo}',
        pathParams: { policyNo: '' },
        queryParams: [],
        body: null,
        idempotent: false
      },
      {
        id: 'get-document',
        hashId: 'get-document',
        label: 'GET policies/{policyNo}/document',
        summary: '确认书 PDF',
        method: 'GET',
        path: '/policies/{policyNo}/document',
        pathParams: { policyNo: '' },
        queryParams: [
          { key: 'lang', value: '', placeholder: 'zh | en (default en)' },
          { key: 'locale', value: '', placeholder: '同 lang' },
          { key: 'language', value: '', placeholder: '同 lang' }
        ],
        body: null,
        idempotent: false,
        responseType: 'blob',
        hint: '返回 Gwofy 投保确认书 PDF，非 reinsurer 保单；source=policy 会 400。'
      },
      {
        id: 'list-policies',
        hashId: 'list-policies',
        label: 'GET policies (list)',
        summary: '保单列表',
        method: 'GET',
        path: '/policies',
        pathParams: {},
        queryParams: [
          { key: 'externalReference', value: '', placeholder: 'ORD-1001' },
          { key: 'policyNo', value: '', placeholder: '' },
          { key: 'createdFrom', value: '', placeholder: 'ISO-8601' },
          { key: 'createdTo', value: '', placeholder: 'ISO-8601' },
          { key: 'cursor', value: '', placeholder: '' }
        ],
        body: null,
        idempotent: false
      },
      {
        id: 'endorse',
        hashId: 'endorse',
        label: 'POST …/endorse (changeShipment)',
        summary: '批改运单',
        method: 'POST',
        path: '/policies/{policyNo}/endorse',
        pathParams: { policyNo: '' },
        queryParams: [],
        body: {
          endorseScene: 'changeShipment',
          changes: {
            trackingNumber: '1Z999AA10123456784',
            carrierCode: 'ups',
            carrierName: 'UPS',
            sailDepartureDate: '2026-08-25',
            estimatedArrivalDate: '2026-09-01'
          }
        },
        idempotent: true,
        hint: '单运单保单使用；已走 syncShipments 的多运单保单会返回 use_sync_shipments。'
      },
      {
        id: 'endorse-change-destination',
        hashId: 'endorse-change-destination',
        label: 'POST …/endorse (changeDestination)',
        summary: '批改目的地',
        method: 'POST',
        path: '/policies/{policyNo}/endorse',
        pathParams: { policyNo: '' },
        queryParams: [],
        body: {
          endorseScene: 'changeDestination',
          changes: {
            destination: { countryCode: 'US', city: 'New York' },
            claimPaymentAddress: { countryCode: 'US', city: 'New York' }
          }
        },
        idempotent: true
      },
      {
        id: 'endorse-sync-shipments',
        hashId: 'endorse-sync-shipments',
        label: 'POST …/endorse (syncShipments)',
        summary: '多运单同步',
        method: 'POST',
        path: '/policies/{policyNo}/endorse',
        pathParams: { policyNo: '' },
        queryParams: [],
        body: {
          endorseScene: 'syncShipments',
          changes: {
            shipments: [
              {
                trackingNumber: '1Z999AA10123456784',
                carrierCode: 'ups',
                carrierName: 'UPS',
                sailDepartureDate: '2026-08-25',
                estimatedArrivalDate: '2026-09-01',
                lineItems: [
                  {
                    itemId: 'LINE-001',
                    sku: 'SKU-001',
                    name: 'Sample product',
                    category: 'apparel',
                    quantity: 1,
                    unitPrice: { amount: 5000, currencyCode: 'USD' }
                  }
                ]
              },
              {
                trackingNumber: 'JD998877665544',
                carrierCode: 'dhl',
                carrierName: 'DHL',
                lineItems: [
                  {
                    itemId: 'LINE-002',
                    sku: 'SKU-002',
                    name: 'Sample product B',
                    category: 'apparel',
                    quantity: 1,
                    unitPrice: { amount: 5000, currencyCode: 'USD' }
                  }
                ]
              }
            ]
          }
        },
        idempotent: true,
        hint:
          '每次提交完整运单列表（1–10）；apply 时勿填 trackingNumber。已有单 trackingNumber 的保单不可使用（409 single_tracking_policy）。'
      },
      {
        id: 'cancel',
        hashId: 'cancel',
        label: 'POST policies/{policyNo}/cancel',
        summary: '取消保单',
        method: 'POST',
        path: '/policies/{policyNo}/cancel',
        pathParams: { policyNo: '' },
        queryParams: [],
        body: {
          cancelReasonCode: 'merchant_request'
        },
        idempotent: true,
        hint: '已有 trackingNumber（含多运单任一运单）时返回 409 cancel_blocked_by_shipment。'
      }
    ]
  },
  {
    id: 'events',
    label: '事件',
    endpoints: [
      {
        id: 'list-events',
        hashId: 'list-events',
        label: 'GET events',
        summary: '事件轮询',
        method: 'GET',
        path: '/events',
        pathParams: {},
        queryParams: [
          { key: 'since', value: '', placeholder: 'cursor / timestamp' },
          { key: 'type', value: '', placeholder: 'policy.insured, ...' }
        ],
        body: null,
        idempotent: false
      }
    ]
  }
]

export function findEndpointById (id) {
  for (const group of endpointGroups) {
    const ep = group.endpoints.find((e) => e.id === id)
    if (ep) return ep
  }
  return null
}

export function findEndpointByHashId (hashId) {
  const key = String(hashId || '').trim()
  if (!key) return null
  for (const group of endpointGroups) {
    const ep = group.endpoints.find((e) => e.hashId === key)
    if (ep) return ep
  }
  return null
}

export function resolvePath (template, pathParams) {
  return template.replace(/\{(\w+)\}/g, (_, key) => {
    const v = pathParams[key]
    if (v === undefined || v === '') throw new Error(`路径参数 ${key} 未填写`)
    return encodeURIComponent(v)
  })
}

/** URL 预览：未填写的路径段保留 {param} 占位符 */
export function resolvePathPreview (template, pathParams) {
  return template.replace(/\{(\w+)\}/g, (_, key) => {
    const raw = pathParams?.[key]
    const v = raw === undefined || raw === null ? '' : String(raw).trim()
    if (!v) return `{${key}}`
    return encodeURIComponent(v)
  })
}

export function buildQueryString (queryParams) {
  const parts = []
  for (const q of queryParams || []) {
    const v = q.value === undefined || q.value === null ? '' : String(q.value).trim()
    if (v !== '') {
      parts.push(`${encodeURIComponent(q.key)}=${encodeURIComponent(v)}`)
    }
  }
  return parts.length ? `?${parts.join('&')}` : ''
}
